import { Subscription } from 'rxjs';

export const Subscriptions = {
    unsubscribeAll(subscriptions: Subscription[]) {
        for (const subscription of subscriptions) subscription.unsubscribe();
    },
};
